import React from "react";

function MyAccount() {
  return (
    <div>
      <h3>MyAccount MyAccount</h3>
    </div>
  );
}

export default MyAccount;
